import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapNodeToApiNodeDto = (values: IEditNodeForm): IPostEditNode | {} => {
  const dataMapping: IPostEditNode = {
    description: values.description,    
    modelID: +values.modelID,
    unitID: +values.unitID,
    hostName: values.hostName,
    x25NodeAddress: values.x25NodeAddress,
    filepath: values.filepath,
    x25NodeNumber: values.x25NodeNumber,
  }
  
  return dataMapping;
}

const editNode = ( {data, nodeId} : {data: IEditNodeForm , nodeId: number}): Promise<string> => {
  const node = mapNodeToApiNodeDto(data);
  return axiosDefaultApi.put(`/api/Nodes/UpdateNode/${nodeId}`, node);
};

type QueryFnType = typeof editNode;

type UseEditNodeOptions = {
  data: IPostEditNode | {};
  nodeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditNode = ({ config }: UseEditNodeOptions) => { 
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Κόμβου.`, 500);
      console.error('Couldnt edit Node', error);
      setIsNotificationVisible(true)
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllNodes"])
      addNotification('Ο Κόμβος Ενημερώθηκε.', 200);
      setIsNotificationVisible(true)
    },
    ...config,
    mutationFn: editNode,
  })
}